// @ts-strict-ignore
import { Calendar } from '@livechat/design-system-icons';
import { format } from 'date-fns';

import { DateFormat } from 'constants/date';
import { type DateRangeFilter, CustomDateRangeFilterId } from 'constants/filters/date-range-filter';
import { Filter } from 'constants/filters/filter';
import { getCustomDateRange } from 'helpers/filters';

import { type FilterConfig, type FilterLabelValue } from '../interfaces';

export const resolutionDateRangeFilterConfig: FilterConfig = {
  title: 'Resolution date',
  multiple: false,
  icon: Calendar,
  getFilterLabelValues: (filterValues: DateRangeFilter): FilterLabelValue[] => {
    if (filterValues === null) {
      return null;
    }

    const dateRangeId: CustomDateRangeFilterId = getCustomDateRange(filterValues.from, filterValues.to);
    const labelsMap = {
      [CustomDateRangeFilterId.Today]: 'Solved today',
      [CustomDateRangeFilterId.Yesterday]: 'Solved yesterday',
      [CustomDateRangeFilterId.Last7Days]: 'Solved in last 7 days',
      [CustomDateRangeFilterId.Last30Days]: 'Solved in last 30 days',
      [CustomDateRangeFilterId.LastMonth]: 'Solved last month',
      [CustomDateRangeFilterId.CurrentMonth]: 'Solved current month',
    };
    const label =
      labelsMap[dateRangeId] ||
      `Solved: ${format(filterValues.from, DateFormat.ISO8601Date)} – ${format(
        filterValues.to,
        DateFormat.ISO8601Date
      )}`;

    return [
      {
        key: Filter.ResolutionDateRange,
        label,
      },
    ];
  },
};
